import { Typography } from '@navi/web-ui/lib/primitives';
import styles from '../../AgentForm.module.scss';
import AgentFormTextbox from './AgentFormTextbox';
import { IAgentBaseLocationProps } from '../../interfaces/types';
import RequiredIcon from '@navi/web-ui/lib/icons/RequiredIcon';

const AgentBaseLocation = (props: IAgentBaseLocationProps) => {
  const {
    latitude,
    longitude,
    control,
    errors,
    isEditDisabled,
    callbackFn,
    showCurrentMonthLabel = true,
    isMandatory = false
  } = props;

  return (
    <div className={styles.locationContainer}>
      <div className="flex">
        <div className="flex">
          <Typography variant="p4" color="var(--navi-color-gray-c2)" className="pr-1">
            {'Agent base location '}
          </Typography>
          {isMandatory ? <RequiredIcon /> : null}
        </div>
        {showCurrentMonthLabel && (
          <Typography variant="p4" color="var(--navi-color-gray-c3)">
            {'(for current month)'}
          </Typography>
        )}
      </div>
      <div className={styles.coordinatesRow}>
        <div className={styles.coordinateField}>
          <div className={styles.inputWrapper}>
            <AgentFormTextbox
              control={control}
              name={latitude}
              rules={{ required: isMandatory }}
              inputLabel={''}
              placeholder={'Enter here'}
              isEditDisabled={isEditDisabled}
              errors={errors}
              styles={styles}
              validationMessage={'Enter latitude value'}
              onChangeCallback={callbackFn}
              isRequired={isMandatory}
            />
          </div>
          <Typography
            variant="p4"
            color="var(--navi-color-gray-c2)"
            className={styles.coordinatesText}
          >
            {'Lat'}
          </Typography>
        </div>
        <div className={styles.coordinateField}>
          <div className={styles.inputWrapper}>
            <AgentFormTextbox
              control={control}
              name={longitude}
              rules={{ required: isMandatory }}
              inputLabel={''}
              placeholder={'Enter here'}
              isEditDisabled={isEditDisabled}
              errors={errors}
              styles={styles}
              validationMessage={'Enter longitude value'}
              onChangeCallback={callbackFn}
              isRequired={isMandatory}
            />
          </div>
          <Typography
            variant="p4"
            color="var(--navi-color-gray-c2)"
            className={styles.coordinatesText}
          >
            {'Long'}
          </Typography>
        </div>
      </div>
    </div>
  );
};

export default AgentBaseLocation;
